import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
   * Logger Factory
   * @namespace isDrawerOpen: check if drower is open
   * @namespace cancel: if true there ara a cancel button
   * @namespace cancelLabel: is the text to show inside the cancel button
   * @namespace action: is the name of action to do after click
   * @namespace actionLabel: is the text to show to the other button
   * @namespace onClickAction: is the action to brought to his parent 
   * @namespace isDrawerOpenChange: brought to his parent the value of is DrawerOpen 
   * <ute-drawer 
      [action]="action" 
      [actionLabel]="actionLabel" 
      [cancel]="cancel"
      [cancelLabel]="cancelLabel"
      [(isDrawerOpen)]="isDrawerOpen" 
      (isDrawerOpenChange)="onChangeDrawer($event)">
*/

@Component({
  selector: 'ute-drawer',
  templateUrl: 'ute-drawer.component.html',
})
export class UteDrawerComponent {
  @Input()  isDrawerOpen: boolean;
  @Input()  isTransparent: boolean;
  @Input()  cancel: boolean = false;
  @Input()  cancelLabel: string;
  @Input()  action: string;
  @Input()  actionLabel: string;
  
  @Output() onClickAction = new EventEmitter;
  @Output() isDrawerOpenChange = new EventEmitter;
  
  constructor() {
  }

  ngOnInit(){
  }

  closeDrawer(){
    this.isDrawerOpenChange.emit(false);
  }

  onClickButton(event){
    this.onClickAction.emit(event);
    this.isDrawerOpenChange.emit(false);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-drawer/ute-drawer.component.ts